import { render, staticRenderFns } from "./applicationManagement.vue?vue&type=template&id=3481a51b&scoped=true"
import script from "./applicationManagement.vue?vue&type=script&lang=js"
export * from "./applicationManagement.vue?vue&type=script&lang=js"
import style0 from "./applicationManagement.vue?vue&type=style&index=0&id=3481a51b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3481a51b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3481a51b')) {
      api.createRecord('3481a51b', component.options)
    } else {
      api.reload('3481a51b', component.options)
    }
    module.hot.accept("./applicationManagement.vue?vue&type=template&id=3481a51b&scoped=true", function () {
      api.rerender('3481a51b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/openPlatform/applicationManagement.vue"
export default component.exports